import { Table, Text } from "melco-ui"
import { useGetAllProductsList } from "../../hooks/product/useGetAllProductsList"
import { useAddRemoveProduct } from "../../hooks/hoops/useAddRemoveProduct"
import { useTranslation } from "react-i18next"
import { useMemo } from "react"


export type HoopProductListProps = {};

export const HoopProductList: React.FC<HoopProductListProps> = () => {
    const { data, onTableConfigChange } = useGetAllProductsList("hoops");
    const { t } = useTranslation();

    const { products, addProducts, removeProducts } = useAddRemoveProduct();

    //  derive selected keys from Formik
    const selectedRowKeys = useMemo(
        () => (products ?? []).map((p: any) => p.product_code),
        [products]
    );


    const columns = [
        {
            title: t('managehoops.tabs.products.drawer.table.columns.name'),
            key: "name",
            dataIndex: "name"
        }
    ];

    //  controlled row selection
    const rowSelection = {
        selectedRowKeys,

        onChange: (newSelectedKeys: React.Key[]) => {
            const currentKeys = selectedRowKeys;

            // ➕ items to add
            const toAdd = (data ?? []).filter(
                (d: any) =>
                    newSelectedKeys.includes(d.code) &&
                    !currentKeys.includes(d.code)
            );

            // ➖ items to remove
            const toRemove = currentKeys.filter(
                (code: any) => !newSelectedKeys.includes(code)
            );

            if (toAdd.length) {
                addProducts(toAdd);
            }

            if (toRemove.length) {
                removeProducts(
                    toRemove.map((code: any) => ({
                        product_code: code
                    }))
                );
            }
        }
    };
    // selectedRowKeys: array of selected IDs (Key[])
    const selectedCount = selectedRowKeys.length;
    return (
        <>

            {selectedCount > 0 && (
                <div style={{ marginBottom: 1, textAlign: "right" }}>
                    <Text >{selectedCount} {t("managehoops.tabs.products.selected_products")}</Text>
                </div>
            )}
            <Table
                dataSource={data}
                columns={columns}
                rowSelection={rowSelection}
                rowKey="code" //  IMPORTANT
                onChange={onTableConfigChange}
            />
        </>
    );
};
